import React,{useContext, useEffect} from 'react';
import { Link, Navigate, Outlet, useNavigate } from 'react-router-dom';
import Sidebar from './components/Partials/Sidebar';
import { Context } from './context/UserContext';

const Panel = () => {
    const context = useContext(Context)
    const navigate = useNavigate();

    let userData = localStorage.getItem('user') != null ? JSON.parse(localStorage.getItem('user')) : {};

    if(userData && Object.keys(userData).length && userData.businessId != null && userData.businessId.length)
        context.setBusinessId(userData.businessId[0])
    else
        context.setBusinessId(0)

    useEffect(() => {
        if(localStorage.getItem('user') == null){
            localStorage.removeItem('user');
            localStorage.removeItem('token');
            localStorage.removeItem('businessId');
            localStorage.removeItem('rl');
            return navigate('/login');
        }
    },[]);

    const logout = e => {
        e.preventDefault();
        localStorage.removeItem('token');
        localStorage.removeItem('businessId');
        localStorage.removeItem('rl');
        localStorage.removeItem('user');
        return navigate('/login');
    }

    const handleToggleSidebar = e => {
        e.preventDefault()
        const element = document.querySelector('.sidebar-mini .app-sidebar')
        if(element.classList.contains('show-mobile')){
            element.classList.remove('show-mobile')
            element.setAttribute('style','right: -270px !important')
        }
        else{
            element.classList.add('show-mobile')
            element.setAttribute('style','right: 0px !important')
        }
    }

    return (
        <div id="app-root">
            <div className="page">
                <div className="page-main">
                    <div className="app-header header sticky">
                        <div className="container-fluid main-container">
                            <div className="d-flex">
                                <a aria-label="Hide Sidebar" className="app-sidebar__toggle" onClick={handleToggleSidebar} data-bs-toggle="sidebar" href="#"></a>
                                <span>{userData.businessTitle}</span>
                                <Link className="logo-horizontal " to="/">
                                    <img src="/assets/images/brand/logo.png" className="header-brand-img desktop-logo" alt="logo" />
                                    <img src="/assets/images/brand/logo-3.png" className="header-brand-img light-logo1"
                                        alt="logo" />
                                </Link>
                                <div className="d-flex order-lg-2 ms-auto header-right-icons">
                                    <button className="navbar-toggler navresponsive-toggler d-lg-none ms-auto" type="button"
                                        data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent-4"
                                        aria-controls="navbarSupportedContent-4" aria-expanded="false"
                                        aria-label="Toggle navigation">
                                        <span className="navbar-toggler-icon fe fe-more-vertical"></span>
                                    </button>
                                    <div className="navbar navbar-collapse responsive-navbar p-0">
                                        <div className="collapse navbar-collapse" id="navbarSupportedContent-4">
                                            <div className="d-flex order-lg-2">
                                                <div className="d-flex country">
                                                    <a className="nav-link icon theme-layout nav-link-bg layout-setting">
                                                        <span className="dark-layout"><i className="fe fe-moon"></i></span>
                                                        <span className="light-layout"><i className="fe fe-sun"></i></span>
                                                    </a>
                                                </div>
                                                {/* <div className="dropdown d-flex">
                                                    <a className="nav-link icon full-screen-link nav-link-bg">
                                                        <i className="fe fe-minimize fullscreen-button"></i>
                                                    </a>
                                                </div> */}
                                                {/* <div className="dropdown  d-flex notifications">
                                                    <a className="nav-link icon" data-bs-toggle="dropdown"><i
                                                        className="fe fe-bell"></i><span className=" pulse"></span>
                                                    </a>
                                                    <div className="dropdown-menu dropdown-menu-end dropdown-menu-arrow">
                                                        <div className="drop-heading border-bottom">
                                                            <div className="d-flex">
                                                                <h6 className="mt-1 mb-0 fs-16 fw-semibold text-dark">اعلانات
                                                                </h6>
                                                            </div>
                                                        </div>
                                                        <div className="notifications-menu">
                                                            <a className="dropdown-item d-flex" href="notify-list.html">
                                                                <div className="me-3 notifyimg  bg-primary brround box-shadow-primary">
                                                                    <i className="fe fe-mail"></i>
                                                                </div>
                                                                <div className="mt-1 wd-80p">
                                                                    <h5 className="notification-label mb-1">برنامه جدید دریافت شد
                                                                    </h5>
                                                                    <span className="notification-subtext">3 روز پیش</span>
                                                                </div>
                                                            </a>
                                                            <a className="dropdown-item d-flex" href="notify-list.html">
                                                                <div className="me-3 notifyimg bg-secondary brround box-shadow-secondary">
                                                                    <i className="fe fe-check-circle"></i>
                                                                </div>
                                                                <div className="mt-1 wd-80p">
                                                                    <h5 className="notification-label mb-1">پروژه شما تایید شده است.</h5>
                                                                    <span className="notification-subtext">2 ساعت قبل</span>
                                                                </div>
                                                            </a>
                                                            <a className="dropdown-item d-flex" href="notify-list.html">
                                                                <div className="me-3 notifyimg bg-success bround box-shadow-success">
                                                                    <i className="fe fe-shopping-cart"></i>
                                                                </div>
                                                                <div className="mt-1 wd-80p">
                                                                    <h5 className="notification-label mb-1">محصول شما تحویل داده شد
                                                                    </h5>
                                                                    <span className="notification-subtext">30 دقیقه قبل</span>
                                                                </div>
                                                            </a>
                                                            <a className="dropdown-item d-flex" href="notify-list.html">
                                                                <div className="me-3 notifyimg bg-pink brround box-shadow-pink">
                                                                    <i className="fe fe-user-plus"></i>
                                                                </div>
                                                                <div className="mt-1 wd-80p">
                                                                    <h5 className="notification-label mb-1">درخواست‌های دوستی</h5>
                                                                    <span className="notification-subtext">1 روز پیش</span>
                                                                </div>
                                                            </a>
                                                        </div>
                                                        <div className="dropdown-divider m-0"></div>
                                                        <a href="notify-list.html"
                                                            className="dropdown-item text-center p-3 text-muted">مشاهده همه
                                                            اعلان</a>
                                                    </div>
                                                </div> */}
                                                <div className="dropdown d-flex profile-1">
                                                    <a href="#" data-bs-toggle="dropdown" className="nav-link leading-none d-flex my-3">
                                                        <img src="/assets/images/users/21.jpg" alt="profile-user"
                                                            className="avatar  profile-user brround cover-image" />
                                                    </a>
                                                    <div className="dropdown-menu dropdown-menu-end dropdown-menu-arrow">
                                                        <div className="drop-heading">
                                                            <div className="text-center">
                                                                <h5 className="text-dark mb-0 fs-14 fw-semibold">{userData.firstName + ' ' + userData.lastName}</h5>
                                                                <small className="text-muted">{userData.roleTitle || '-'}</small>
                                                            </div>
                                                        </div>
                                                        <div className="dropdown-divider m-0"></div>
                                                        <Link to="settings" className="dropdown-item">
                                                            <i className="dropdown-icon fe fe-settings"></i> تنظیمات
                                                        </Link>
                                                        <Link to="users/change-password" className="dropdown-item">
                                                            <i className="dropdown-icon fe fe-lock"></i> تغییر رمز عبور
                                                        </Link>
                                                        <a className="dropdown-item" href="#" onClick={e => logout(e)}>
                                                            <i className="dropdown-icon fe fe-alert-circle"></i> خروج از سیستم
                                                        </a>
                                                    </div>
                                                </div>
                                                <p className="mt-4">{userData.firstName + ' ' + userData.lastName}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Sidebar />
                    <div className="main-content app-content mt-0">
                        <div className="side-app">
                            <div className="main-container container-fluid">
                                <div className="page-header">
                                    <h1 className="page-title">خالی</h1>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        {localStorage.getItem('token') && localStorage.getItem('token') != null ? <Outlet /> : <Navigate to="/login" />}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <footer className="footer">
                    <div className="container">
                        <div className="row align-items-center flex-row-reverse">
                            <div className="col-md-12 col-sm-12 text-center">
                                طراحی و توسعه یافته توسط <a href="https://sabinarya.com">تیم فناوری اطلاعات</a>
                            </div>
                        </div>
                    </div>
                </footer>
            </div>
            <a href="#top" id="back-to-top"><i className="fa fa-angle-up"></i></a>
        </div>
    );
}

export default Panel;